module.exports = __webpack_public_path__ + "static/microscopeModule-f51d1bc653a544788d7dc306b26850bb.png";